import React, { useState } from "react";
import { motion, useMotionValueEvent, useReducedMotion, useScroll } from "motion/react";
import { IconChevronDown } from "@tabler/icons-react";

export function ScrollCue() {
  const { scrollY } = useScroll();
  const reduceMotion = useReducedMotion();
  const [atTop, setAtTop] = useState(true);

  useMotionValueEvent(scrollY, "change", (y) => setAtTop(y <= 8));

  return (
    <button
      type="button"
      aria-label="Scroll down"
      tabIndex={atTop ? 0 : -1}
      onClick={() =>
        window.scrollBy({
          top: window.innerHeight * 0.85,
          behavior: reduceMotion ? "auto" : "smooth",
        })
      }
      className={`fixed bottom-4 left-1/2 z-10 hidden h-11 w-11 -translate-x-1/2 items-center justify-center rounded-full text-white/40 transition-opacity duration-500 hover:text-white/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary lg:flex ${
        atTop ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <motion.span
        animate={reduceMotion ? undefined : { y: [0, 5, 0] }}
        transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        className="flex"
      >
        <IconChevronDown className="size-6" stroke={1.5} />
      </motion.span>
    </button>
  );
}
